/*
 * Application State should be all within this file.
 */

const app = {
  state: {
    formData: {}
  },
  mutations: {
    SET_FORM(state, formData) {
      state.formData = formData;
    }
  },
  actions: {
    setForm({ commit }, value) {
      console.log(value);
      commit("SET_FORM", value);
    },
    mapFromDatastore({ commit, state }, payload) {
      /*
       * This is called whenever the Datastore/entry changes.
       * This is an opportunity for you to map stored values
       * back into your state.
       */
      let _payload = "";
      try {
        _payload = JSON.parse(payload);
      } catch (e) {
        _payload = payload;
      }

      console.log("Mapping!", _payload);

      /*
       * Call a mutation to put your datastore payload into your app state
       */
      commit("SET_FORM", _payload?.formData ?? state.formData);
    }
  },
  getters: {
    // Lets get all the forms
    getForm: (state) => state.formData,
    mapToDatastore(state) {
      /*
       * Datastore Payload is only used whenever you're using the
       * Datastore (or Datasheets). This is an object
       */
      console.log(state.formData);

      let payload = {
        formData: state.formData
      };

      payload = JSON.stringify(payload);

      return payload;
    }
  }
};

export default app;
